export var EmailNotification;
(function (EmailNotification) {
    EmailNotification["SEND_TEACHER"] = "SEND_TEACHER";
    EmailNotification["SEND_THRESHOLD"] = "SEND_THRESHOLD";
    EmailNotification["SEND_FLAGS"] = "SEND_FLAGS";
})(EmailNotification || (EmailNotification = {}));
